export const Pause = (props) => (
  // <svg
  //   style={{ ...props?.style }}
  //   width='20'
  //   height='20'
  //   viewBox='0 0 20 20'
  //   fill='none'
  //   xmlns='http://www.w3.org/2000/svg'
  // >
  //   <circle cx='10' cy='10' r='10' fill='#FCAF17' />
  //   <path
  //     d='M11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V6Z'
  //     fill='white'
  //   />
  //   <path
  //     d='M7 6C7 5.44772 7.44772 5 8 5C8.55228 5 9 5.44772 9 6V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V6Z'
  //     fill='white'
  //   />
  // </svg>
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='12' cy='12' r='10' fill='#FCAF17' />
    <path
      d='M13 8C13 7.44772 13.4477 7 14 7C14.5523 7 15 7.44772 15 8V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V8Z'
      fill='white'
    />
    <path
      d='M9 8C9 7.44772 9.44772 7 10 7C10.5523 7 11 7.44772 11 8V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V8Z'
      fill='white'
    />
  </svg>
);

export const Excluded = (props) => (
  // <svg
  //   style={{ ...props?.style }}
  //   width='20'
  //   height='20'
  //   viewBox='0 0 20 20'
  //   fill='none'
  //   xmlns='http://www.w3.org/2000/svg'
  // >
  //   <circle cx='10' cy='10' r='10' fill='#FCAF17' />
  //   <path
  //     d='M11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V6Z'
  //     fill='white'
  //   />
  //   <path
  //     d='M7 6C7 5.44772 7.44772 5 8 5C8.55228 5 9 5.44772 9 6V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V6Z'
  //     fill='white'
  //   />
  // </svg>
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='12' cy='12' r='10' fill='#F05435' />
    <path
      d='M13 8C13 7.44772 13.4477 7 14 7C14.5523 7 15 7.44772 15 8V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V8Z'
      fill='white'
    />
    <path
      d='M9 8C9 7.44772 9.44772 7 10 7C10.5523 7 11 7.44772 11 8V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V8Z'
      fill='white'
    />
  </svg>
);

export const PauseScheduler = (props) => (
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='12' cy='12' r='10' fill='#FCAF17' />
    <path
      d='M13 8C13 7.44772 13.4477 7 14 7C14.5523 7 15 7.44772 15 8V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V8Z'
      fill='white'
    />
    <path
      d='M9 8C9 7.44772 9.44772 7 10 7C10.5523 7 11 7.44772 11 8V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V8Z'
      fill='white'
    />
    <circle
      cx='18.5'
      cy='18.5'
      r='5'
      transform='rotate(90 18.5 18.5)'
      fill='white'
      stroke='#FCAF17'
    />
    <path
      d='M18.5 15.75L18.5 18.5L21.25 18.5'
      stroke='#FCAF17'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const Start = (props) => (
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
      fill='#2DB0A9'
    />
    <path
      d='M15.2929 12.707C15.6834 12.3165 15.6834 11.6833 15.2929 11.2928L11.7071 7.70701C11.0771 7.07704 10 7.52321 10 8.41411V15.5857C10 16.4766 11.0771 16.9228 11.7071 16.2928L15.2929 12.707Z'
      fill='white'
    />
  </svg>
);

export const StartScheduler = (props) => (
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='12' cy='12' r='10' fill='#2DB0A9' />
    <path
      d='M15.2929 12.7071C15.6834 12.3166 15.6834 11.6834 15.2929 11.2929L11.7071 7.70711C11.0771 7.07714 10 7.52331 10 8.41421V15.5858C10 16.4767 11.0771 16.9229 11.7071 16.2929L15.2929 12.7071Z'
      fill='white'
    />
    <circle
      cx='18.5'
      cy='18.5'
      r='5'
      transform='rotate(90 18.5 18.5)'
      fill='white'
      stroke='#2DB0A9'
    />
    <path
      d='M18.5 15.75L18.5 18.5L21.25 18.5'
      stroke='#2DB0A9'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const DraftIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='2' y='2' width='20' height='20' rx='3' fill='#475569' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.4482 6C15.0005 6 15.4482 6.44772 15.4482 7V7.08963C15.4482 7.64192 15.0005 8.08963 14.4482 8.08963H6.00009C5.4478 8.08963 5.00009 7.64192 5.00009 7.08963V7C5.00009 6.44772 5.4478 6 6.00009 6H14.4482ZM12 20V18L16.5 13.5L18.5 15.5L14 20H12ZM19 12L20 13V14L19 15L17 13L18 12H19ZM15 11C15 10.4477 14.5523 10 14 10H6C5.44771 10 5 10.4477 5 11C5 11.5523 5.44771 12 6 12H14C14.5523 12 15 11.5523 15 11ZM9 14C9.55229 14 10 14.4477 10 15C10 15.5523 9.55229 16 9 16H6C5.44772 16 5 15.5523 5 15C5 14.4477 5.44772 14 6 14H9Z'
      fill='white'
    />
  </svg>
);
